import "./ScaffoldingInCamberley.module.css";
import Header from "@/reusable_sections/Header";
import Camberley from "./sections/Camberley";
import LocalisedIntro from "./sections/LocalisedIntro";
import SafetyAccess from "./sections/SafetyAccess";
import FaqCamberley from "./sections/FaqCamberley";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function ScaffoldingInCamberleyPage() {
  return <div>
      <Header />
      <Camberley />
      <LocalisedIntro />
      <SafetyAccess />
      <FaqCamberley />
      <FinalCta />
      <Footer />
    </div>;
}